import { CAMERA_ICON_VIEWBOX_SIZE, MAP_CAMERA_BASE_ICON_SIZE } from '../constants';
import type { MapRenderCameraModel } from '../types';

/**
 * SVG transforms that position and rotate a camera icon without rotating its separately rendered label.
 */
export interface MapCameraTransform {
  /** Optional outer rotation around the camera placement centre, or `null` when not needed. */
  readonly rotation: string | null;
  /** Inner translation and scale that maps the canonical camera path to its rendered size. */
  readonly icon: string;
}

/**
 * Calculates canonical nested SVG transforms for one camera marker.
 *
 * @param camera Immutable camera placement whose size, position and rotation determine the transforms.
 * @returns New outer rotation and inner path-placement transform strings; does not mutate `camera`.
 */
export function resolveCameraTransform(camera: MapRenderCameraModel): MapCameraTransform {
  const iconSize = MAP_CAMERA_BASE_ICON_SIZE * camera.icon.sizeMultiplier;
  const translateX = camera.positionX - iconSize / 2;
  const translateY = camera.positionY - iconSize / 2;
  const scaleFactor = iconSize / CAMERA_ICON_VIEWBOX_SIZE;

  return {
    rotation:
      camera.rotationDegrees === 0
        ? null
        : `rotate(${camera.rotationDegrees} ${camera.positionX} ${camera.positionY})`,
    icon: `translate(${translateX} ${translateY}) scale(${scaleFactor} ${scaleFactor})`,
  };
}
